import { render, staticRenderFns } from "./CommentModal.vue?vue&type=template&id=2bd311bd&scoped=true&"
import script from "./CommentModal.vue?vue&type=script&lang=ts&"
export * from "./CommentModal.vue?vue&type=script&lang=ts&"
import style0 from "./CommentModal.vue?vue&type=style&index=0&id=2bd311bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd311bd",
  null
  
)

export default component.exports